import { searchBox } from 'instantsearch.js/es/widgets';
import { slideDown } from '../../helpers';

const DEBOUNCE_MS = 300;
let debounceTimer;

export default function SearchBox(container = '#searchbox') {
	const searchInput = container instanceof Element ? container : document.querySelector(container),
		placeholder = searchInput?.dataset?.placeholder;

	const hits = document.querySelector('[data-algolia-hits]'),
		urlParams = new URLSearchParams(window.location.search),
		hasQParam = urlParams.has('q');

	if (hits && !hasQParam) {
		hits.style.display = 'none';
	}

	return searchBox({
		container,
		placeholder: placeholder || strl_vars.search_label,
		showReset: false,
		showSubmit: true,
		showLoadingIndicator: true,
		autofocus: true,
		cssClasses: {
			form: 'relative',
			input: 'h-16! pr-2! w-full bg-white! [&:placeholder-shown+.submit-btn]:flex hocus:border-secondary-140!',
			submit: 'submit-btn p-0! flex-center aspect-square h-[calc(100%-1rem)] absolute top-1/2 right-2 -translate-y-1/2 btn primary text-white! hidden hocus:!opacity-70 outline-0 ',
			submitIcon: 'size-4 fill-white',
		},
		queryHook(query, search) {
			clearTimeout(debounceTimer);

			if (query.length > 2) {
				debounceTimer = setTimeout(() => {
					if (hits) {
						slideDown(hits);
					}
					search(query);
				}, DEBOUNCE_MS);
			} else if (hits) {
				hits.style.display = 'none';
			}
		},
	});
}
